import { graphql } from "../__generated__/gql";

/** Growth / feasibility CPY + PCI + metadata query (explore tool). */
export const CPY_GROWTH_QUERY = graphql(`
  query CPY_growth(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int!
    $countryId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
    $hs12: Boolean!
    $hs22: Boolean!
    $hs92: Boolean!
    $sitc: Boolean!
  ) {
    countryProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      countryId: $countryId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      productId
      productLevel
      year
      exportValue
      importValue
      exportRca
      isNew
      productStatus
      cog
      distance
      normalizedPci
      normalizedCog
      normalizedDistance
    }
    productYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      productId
      year
      pci
      exportValue
      importValue
      exportValueGrowth5: exportValueConstGrowth5
    }
    metadata_12: productHs12 @include(if: $hs12) {
      ...ProductMetadata
    }
    metadata_22: productHs22 @include(if: $hs22) {
      ...ProductMetadata
    }
    metadata_92: productHs92 @include(if: $hs92) {
      ...ProductMetadata
    }
    metadata_sitc: productSitc @include(if: $sitc) {
      ...ProductMetadata
    }
    countryYear: countryYear(
      countryId: $countryId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      exportValue
      eci
    }
    countryYearThresholds(
      countryId: $countryId
      yearMin: $yearMin
      yearMax: $yearMax
      productClass: $productClass
    ) {
      variable
      min
      percentile10
      percentile20
      percentile30
      percentile40
      percentile50
      percentile60
      percentile70
      percentile80
      percentile90
      max
    }
  }
`);

export default CPY_GROWTH_QUERY;
